import axios from 'axios'

export const axiosWithCustomBaseUrlGetMethod = (url, params, baseURL) => {
  return axios({ method: 'GET', url, params, baseURL })
}
